import React from 'react';
import { ProjectPLRow as ProjectPLRowData } from '../../utils/projectPL';
import ProjectPLBudgetPanel from './ProjectPLBudgetPanel';

interface ProjectPLReadOnlyDetailProps {
  row: ProjectPLRowData;
  formatCurrencyFull: (n: number) => string;
}

const ProjectPLReadOnlyDetail: React.FC<ProjectPLReadOnlyDetailProps> = ({ row, formatCurrencyFull }) => {
  return (
    <div className="sa-ppl-completed-detail">
      <ProjectPLBudgetPanel
        row={row}
        formatCurrencyFull={formatCurrencyFull}
        readOnly
      />
    </div>
  );
};

export default ProjectPLReadOnlyDetail;
